function processNode(node) {
  if (!node) return '';

  let html = '';

  switch (node.type) {
    case 'text':
      {
        let text = node.value || '';
        if (node.bold) text = `<strong>${text}</strong>`;
        if (node.italic) text = `<em>${text}</em>`;
        html += text;
      }
      break;
    case 'paragraph':
      html += `<p>`;
      if (node.children) {
        node.children.forEach((child) => {
          html += processNode(child);
        });
      }
      html += `</p>`;
      break;
    case 'list':
      html += `<ul>`;
      if (node.children) {
        node.children.forEach((child) => {
          html += processNode(child);
        });
      }
      html += `</ul>`;
      break;
    case 'list_item':
      html += `<li>`;
      if (node.children) {
        node.children.forEach((child) => {
          html += processNode(child);
        });
      }
      html += `</li>`;
      break;
    case 'heading':
      {
        const headingLevel = node.level || 1;
        html += `<h${headingLevel}>`;
        if (node.children) {
          node.children.forEach((child) => {
            html += processNode(child);
          });
        }
        html += `</h${headingLevel}>`;
      }
      break;
    case 'image':
      if (node.src) {
        html += `<img src="${node.src}" alt="${node.alt || ''}">`;
      }
      break;
    case 'link':
      if (node.url) {
        html += `<a href="${node.url}" target="_blank" rel="noopener noreferrer">`;
        if (node.children) {
          node.children.forEach((child) => {
            html += processNode(child);
          });
        }
        html += `</a>`;
      }
      break;
    default:
      console.warn('Unknown node type:', node.type);
  }

  return html;
}

const richTextToHTML = (data) => {
  if (!data || !data.children) return '';

  let html = '';

  data.children.forEach((child) => {
    html += processNode(child);
  });

  return html;
};

export default richTextToHTML;
